import { render } from "./TimeTravelerHohei.vue?vue&type=template&id=2c8d34ac"
import script from "./TimeTravelerHohei.vue?vue&type=script&lang=js"
export * from "./TimeTravelerHohei.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/app/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__